/* caasi-korting.js (02-09-2026)
 *
 * Een ding: de knoppen "Toevoegen" bij de suggesties onder de voordeel-meter
 * in de winkelwagen (snippets/caasi-staffelkorting.liquid). Staat hier en
 * niet in de snippet, omdat het thema de winkelwagen na elke wijziging
 * opnieuw rendert: een script in de snippet zou dan elke keer opnieuw een
 * afhandelaar binden, en een klik zou het artikel twee keer toevoegen.
 * Delegatie op document, dus een keer gebonden voor de hele pagina.
 */
(function () {
  if (window.caasiKortingGebonden) { return; }
  window.caasiKortingGebonden = true;

  document.addEventListener('click', function (e) {
    var knop = e.target.closest && e.target.closest('[data-caasi-cart-add]');
    if (!knop || knop.disabled) { return; }
    e.preventDefault();
    var id = knop.getAttribute('data-caasi-cart-add');
    if (!id) { return; }
    var origineel = knop.textContent;
    knop.disabled = true;
    /* Teksten komen uit de knop zelf (data-tekst-*), gevuld door Liquid in de taal
       van de winkel; de Nederlandse tekst is alleen de terugval. */
    knop.textContent = knop.getAttribute('data-tekst-bezig') || 'Bezig...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: id, quantity: 1 })
    }).then(function (r) {
      if (!r.ok) { throw new Error('afgewezen'); }
      knop.textContent = knop.getAttribute('data-tekst-klaar') || 'Toegevoegd';
      /* Op de winkelwagenpagina is herladen de enige manier om regels,
         totalen, de korting van Shopify en de meter allemaal kloppend te
         krijgen. In de lade volstaat de verversing van het thema. */
      if (document.querySelector('[data-section-type="cart"]')) {
        window.location.reload();
      } else {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }
    }).catch(function () {
      knop.disabled = false;
      knop.textContent = origineel;
    });
  });
})();

/* Winkelscore van Feedback Company spiegelen naar elk [data-caasi-fc]-element
   (menu, hero). Bron is de widget in de USP-balk; zolang die niets geleverd
   heeft blijft het element verborgen. Zelfde aanpak als de productpagina. */
(function () {
  var doelen = document.querySelectorAll('[data-caasi-fc]');
  if (!doelen.length) { return; }
  var pogingen = 0;
  /* Vijf sterren, elk gevuld naar rato: 8,9/10 = 4,45 sterren, dus vier vol
     en de vijfde voor 45 procent. Het verloop per ster heeft een eigen id,
     anders delen alle blokken op de pagina het eerste verloop. */
  function sterren(s5, blok) {
    var html = '';
    for (var k = 0; k < 5; k++) {
      var f = Math.max(0, Math.min(1, s5 - k));
      var id = 'caasi-ster-' + blok + '-' + k;
      var p = Math.round(f * 100) + '%';
      html += '<svg viewBox="0 0 24 24" aria-hidden="true"><defs><linearGradient id="' + id + '">'
        + '<stop offset="' + p + '" class="caasi-score__ster-vol"/>'
        + '<stop offset="' + p + '" class="caasi-score__ster-leeg"/></linearGradient></defs>'
        + '<polygon fill="url(#' + id + ')" points="12,2 15.1,8.6 22,9.5 17,14.4 18.2,21.5 12,18.1 5.8,21.5 7,14.4 2,9.5 8.9,8.6"/></svg>';
    }
    return html;
  }
  function vul() {
    var score = document.querySelector('.__fbcw__bar-widget__score');
    var aantal = document.querySelector('.__fbcw__bar-widget__amount-of-reviews');
    if (!score || !aantal) {
      if (++pogingen < 60) { setTimeout(vul, 300); }
      return;
    }
    /* Nederlands: 8,9; andere talen (Engels): 8.9 */
    var nlTaal = (document.documentElement.lang || 'nl').toLowerCase().indexOf('nl') === 0;
    var s = (score.textContent || '').trim();
    s = nlTaal ? s.replace('.', ',') : s.replace(',', '.');
    var a = (aantal.textContent || '').trim().replace(/[^0-9.]/g, '');
    if (!s || !a) { return; }
    var score10 = parseFloat(s.replace(',', '.'));
    for (var i = 0; i < doelen.length; i++) {
      var sc = doelen[i].querySelector('[data-caasi-fc-score]');
      var ct = doelen[i].querySelector('[data-caasi-fc-count]');
      var st = doelen[i].querySelector('[data-caasi-fc-stars]');
      if (sc) { sc.textContent = s; }
      if (ct) { ct.textContent = a; }
      if (st && !isNaN(score10)) { st.innerHTML = sterren(score10 / 2, i); }
      doelen[i].hidden = false;
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', vul);
  } else { vul(); }
})();

/* Winkelwagenpagina: op mobiel een plakbalk met totaal en afrekenknop zodra
   de echte knop uit beeld is. Het thema vervangt de hele sectie na elke
   wijziging (cart:rerendered), dus de waarnemer wordt dan opnieuw gezet. */
(function () {
  var mq = window.matchMedia('(max-width: 999px)');
  var waarnemer = null;
  function zet() {
    var balk = document.querySelector('[data-caasi-cart-plak]');
    var knop = document.querySelector('.caasi-cart__afrekenen');
    if (waarnemer) { waarnemer.disconnect(); waarnemer = null; }
    document.documentElement.classList.remove('caasi-cart-plak-actief');
    if (!balk || !knop || !('IntersectionObserver' in window)) { return; }
    var buitenBeeld = false;
    function toon() {
      var aan = buitenBeeld && mq.matches;
      balk.hidden = !aan;
      document.documentElement.classList.toggle('caasi-cart-plak-actief', aan);
      /* In de themavoorvertoning staat onderaan de vaste balk van Shopify
         (67px op 375); daar schuift de plakbalk bovenop. */
      var voorvertoning = document.getElementById('preview-bar-iframe');
      balk.style.bottom = voorvertoning ? Math.round(voorvertoning.getBoundingClientRect().height) + 'px' : '';
    }
    waarnemer = new IntersectionObserver(function (entries) {
      var e = entries[entries.length - 1];
      /* Alleen als de knop ONDER het scherm ligt: daarboven (na scrollen
         langs het overzicht) staat de klant bij de suggesties en is de
         balk een sluiproute terug naar afrekenen, dus ook dan tonen. */
      buitenBeeld = !e.isIntersecting;
      toon();
    }, { threshold: 0 });
    waarnemer.observe(knop);
    if (mq.addEventListener) { mq.addEventListener('change', toon); }
    window.addEventListener('scroll', toon, { passive: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', zet);
  } else { zet(); }
  document.addEventListener('cart:rerendered', zet);
})();

/* Categoriepagina: lange filterlijsten (soms 50 producttypes) laten er acht
   zien, plus een knop "Toon alle N". Aangevinkte waarden blijven altijd
   zichtbaar. Het thema tekent de filters na elke wijziging opnieuw, dus een
   waarnemer zet het opnieuw. */
(function () {
  var MAX = 8;
  function inkorten() {
    var lijsten = document.querySelectorAll('.collection__filter-checkbox-list');
    for (var i = 0; i < lijsten.length; i++) {
      (function (lijst) {
        if (lijst.getAttribute('data-caasi-ingekort')) { return; }
        /* 16-10-2026: het toestelfilter wordt per familie ingeklapt (hieronder),
           niet ingekort. */
        if (lijst.closest('[data-caasi-filter="geschikt-voor"]')) { return; }
        var items = Array.prototype.slice.call(lijst.children);
        if (items.length <= MAX + 2) { return; }
        lijst.setAttribute('data-caasi-ingekort', 'dicht');
        var extra = [];
        for (var k = 0; k < items.length; k++) {
          var aangevinkt = items[k].querySelector('input:checked');
          if (k >= MAX && !aangevinkt) { extra.push(items[k]); }
        }
        if (!extra.length) { return; }
        var knop = document.createElement('button');
        knop.type = 'button';
        knop.className = 'caasi-filter-meer';
        function zet(open) {
          for (var m = 0; m < extra.length; m++) { extra[m].hidden = !open; }
          lijst.setAttribute('data-caasi-ingekort', open ? 'open' : 'dicht');
          knop.textContent = open ? 'Toon minder' : 'Toon alle ' + items.length + ' opties';
          knop.classList.toggle('is-open', open);
        }
        knop.addEventListener('click', function () {
          zet(lijst.getAttribute('data-caasi-ingekort') !== 'open');
        });
        zet(false);
        lijst.parentNode.insertBefore(knop, lijst.nextSibling);
      })(lijsten[i]);
    }
  }
  var wacht = null;
  function later() {
    clearTimeout(wacht);
    wacht = setTimeout(inkorten, 60);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inkorten);
  } else { inkorten(); }
  if ('MutationObserver' in window) {
    new MutationObserver(later).observe(document.body, { childList: true, subtree: true });
  }
})();

/* Mobiel menu: begint onder de header. De header blijft bovenop staan (custom
   .css geeft hem z-index 999999), dus het menu meet bij het openen waar de
   header ophoudt en zet dat als bovenrand. */
(function () {
  var menu = document.getElementById('mobile-menu');
  if (!menu || !menu.classList.contains('caasi-mm')) { return; }
  function meet() {
    var header = document.querySelector('.header');
    if (!header) { return; }
    var onder = Math.round(header.getBoundingClientRect().bottom);
    if (onder > 0) { menu.style.setProperty('--caasi-mm-top', onder + 'px'); }
  }
  meet();
  new MutationObserver(function () {
    if (menu.getAttribute('aria-hidden') === 'false') { meet(); }
  }).observe(menu, { attributes: true, attributeFilter: ['aria-hidden'] });
  window.addEventListener('resize', meet);
})();

/* --- Megamenu onder de eigen categorie (04-09-2026) -----------------------
   Het paneel (caasi-menu.css) hing gecentreerd onder de hele balk. Wie links
   op "Beauty & Verzorging" staat moet dan schuin naar het midden en glijdt
   onderweg over "Elektronica": ander menu (eigenaar). Hier krijgt het paneel
   de linkerkant van het item, binnen de kolom gehouden: voor de items rechts
   schuift het op tot aan de rechter kolomrand. Via css-variabelen, zodat de
   css zonder script gewoon blijft centreren. Past het paneel niet in de
   kolom (smalle schermen), dan blijft het gecentreerd. */
(function () {
  var bar = document.querySelector('.nav-bar');
  if (!bar) { return; }
  function plaats(link) {
    var item = link.closest('.nav-bar__item');
    var paneel = item && item.querySelector('.mega-menu.caasi-mega');
    var kolom = bar.querySelector('.container');
    if (!paneel || !kolom) { return; }
    var kr = kolom.getBoundingClientRect();
    var ks = getComputedStyle(kolom);
    var links = kr.left + parseFloat(ks.paddingLeft);
    var rechts = kr.right - parseFloat(ks.paddingRight);
    var breedte = paneel.offsetWidth || Math.min(940, document.documentElement.clientWidth - 48);
    if (breedte >= rechts - links) {
      paneel.style.removeProperty('--caasi-mega-left');
      paneel.style.removeProperty('--caasi-mega-shift');
      return;
    }
    var gewenst = item.getBoundingClientRect().left;
    var x = Math.max(links, Math.min(gewenst, rechts - breedte)) - bar.getBoundingClientRect().left;
    paneel.style.setProperty('--caasi-mega-left', Math.round(x) + 'px');
    paneel.style.setProperty('--caasi-mega-shift', 'none');
  }
  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      if (m.target.getAttribute && m.target.getAttribute('aria-expanded') === 'true') { plaats(m.target); }
    });
  }).observe(bar, { attributes: true, attributeFilter: ['aria-expanded'], subtree: true });
  bar.addEventListener('mouseenter', function (e) {
    var link = e.target && e.target.closest && e.target.closest('.nav-bar__link');
    if (link) { plaats(link); }
  }, true);
})();

/* 16-10-2026 (filteraudit): het toestelfilter "Geschikt voor".
   1. Per familie (iPhone, Samsung Galaxy, iPad, ...) met de grootste familie
      open en nieuwste model eerst, in plaats van 62 regels op alfabet waarvan
      er acht zichtbaar waren (Galaxy A17 tot A54). De li's van het thema
      verhuizen naar een sublijst, dus vinkjes, tellers en de ajax-herlaad van
      het thema blijven zoals ze waren. "Universeel" is geen toestel en wordt
      verborgen.
   2. Het gekozen toestel gaat mee in de chips naar de zustercollectie en in
      een regel boven het raster ("Ook een screenprotector voor je iPhone
      17?"), met het aantal opgehaald via de Section Rendering API. Alleen in
      het profiel 'toestel' (data-caasi-profiel op de sectie). */
(function () {
  var PARAM = 'filter.p.m.caasi.geschikt_voor';
  var ZUSTER = {
    telefoonhoesjes: { handle: 'screenprotectors', vraag: 'Ook een screenprotector voor je %s?', meer: 'Bekijk %n screenprotectors', een: 'Bekijk 1 screenprotector', los: 'Bekijk de screenprotectors' },
    screenprotectors: { handle: 'telefoonhoesjes', vraag: 'Hoesje erbij voor je %s?', meer: 'Bekijk %n hoesjes', een: 'Bekijk 1 hoesje', los: 'Bekijk de hoesjes' }
  };

  function familie(naam) {
    if (/^iPhone/.test(naam)) { return 'iPhone'; }
    if (/^iPad/.test(naam)) { return 'iPad'; }
    if (/^AirPods/.test(naam)) { return 'AirPods'; }
    if (/^Apple Watch/.test(naam)) { return 'Apple Watch'; }
    if (/^Galaxy Tab/.test(naam)) { return 'Galaxy Tab'; }
    if (/^Galaxy/.test(naam)) { return 'Samsung Galaxy'; }
    if (/^Pixel/.test(naam)) { return 'Google Pixel'; }
    return 'Overig';
  }
  /* Sorteersleutel: reeks (S voor Z voor A; Pro voor Air voor iPad voor Mini),
     dan nummer aflopend (nieuwste eerst), dan uitvoering (Pro Max, Pro, Plus,
     basis, FE, Mini/e). */
  function sleutel(naam) {
    var reeks = 0, m;
    if ((m = /^Galaxy (?:Tab )?([SZA])/.exec(naam))) { reeks = { S: 0, Z: 1, A: 2 }[m[1]]; }
    if ((m = /^iPad ?(Pro|Air|Mini)?/.exec(naam)) && /^iPad/.test(naam)) { reeks = { Pro: 0, Air: 1, Mini: 3 }[m[1]] || 2; }
    var n = 0, g = /(\d+)/.exec(naam);
    if (g) { n = parseInt(g[1], 10); }
    if (/^iPhone X/.test(naam)) { n = 10; }
    if (/^iPhone Air/.test(naam)) { n = 17; }
    if (/^iPhone SE/.test(naam)) { n = 8; }
    var v = 3;
    if (/(Pro Max|Ultra)\b/.test(naam)) { v = 0; }
    else if (/\bPro\b/.test(naam)) { v = 1; }
    else if (/\bPlus\b/.test(naam)) { v = 2; }
    else if (/\bFE\b/.test(naam)) { v = 4; }
    else if (/\bMini\b|\d+e$/.test(naam)) { v = 5; }
    if (/^iPhone Air/.test(naam)) { v = 2.5; }
    return [reeks, -n, v, naam];
  }
  function vergelijk(a, b) {
    for (var i = 0; i < a.length; i++) {
      if (a[i] < b[i]) { return -1; }
      if (a[i] > b[i]) { return 1; }
    }
    return 0;
  }
  /* Het label is "iPhone 17 (14)" uit Liquid, maar een script in theme.liquid
     zet de teller in een span (filter-count-right); allebei de vormen lezen. */
  function naamVan(li) {
    var lab = li.querySelector('label');
    if (!lab) { return ''; }
    var naam = '';
    for (var i = 0; i < lab.childNodes.length; i++) {
      if (lab.childNodes[i].nodeType === 3) { naam += lab.childNodes[i].textContent; }
    }
    return naam.replace(/\s*\(\d+\)\s*$/, '').trim();
  }
  function telling(li) {
    var lab = li.querySelector('label');
    if (!lab) { return 0; }
    var sp = lab.querySelector('.filter-count-right');
    var m = sp ? /(\d+)/.exec(sp.textContent) : /\((\d+)\)\s*$/.exec(lab.textContent);
    return m ? parseInt(m[1], 10) : 0;
  }

  function groepeer(lijst) {
    if (lijst.getAttribute('data-caasi-families')) { return; }
    var items = Array.prototype.slice.call(lijst.children).filter(function (li) { return li.tagName === 'LI'; });
    if (items.length < 6) { return; }
    lijst.setAttribute('data-caasi-families', '1');
    var fams = {}, volgorde = [], aangevinkt = {}, ietsAangevinkt = false;
    items.forEach(function (li) {
      var naam = naamVan(li);
      if (naam === 'Universeel') { li.hidden = true; return; }
      var f = familie(naam);
      li.setAttribute('data-caasi-naam', naam);
      if (!fams[f]) { fams[f] = []; volgorde.push(f); }
      fams[f].push(li);
      if (li.querySelector('input:checked')) { aangevinkt[f] = true; ietsAangevinkt = true; }
    });
    function som(lis) {
      var t = 0;
      lis.forEach(function (li) { t += telling(li); });
      return t;
    }
    volgorde.sort(function (a, b) { return som(fams[b]) - som(fams[a]); });
    volgorde.forEach(function (f, i) {
      var lis = fams[f].sort(function (a, b) {
        return vergelijk(sleutel(a.getAttribute('data-caasi-naam')), sleutel(b.getAttribute('data-caasi-naam')));
      });
      var wrap = document.createElement('li');
      wrap.className = 'caasi-familie';
      var kop = document.createElement('button');
      kop.type = 'button';
      kop.className = 'caasi-familie__kop';
      var naamEl = document.createElement('span');
      naamEl.textContent = f;
      var nEl = document.createElement('span');
      nEl.className = 'caasi-familie__n';
      nEl.textContent = lis.length === 1 ? '1 model' : lis.length + ' modellen';
      kop.appendChild(naamEl);
      kop.appendChild(nEl);
      var sub = document.createElement('ul');
      sub.className = 'caasi-familie__lijst';
      lis.forEach(function (li) { sub.appendChild(li); });
      var open = ietsAangevinkt ? !!aangevinkt[f] : i === 0;
      if (open) { wrap.classList.add('is-open'); }
      kop.setAttribute('aria-expanded', open ? 'true' : 'false');
      kop.addEventListener('click', function () {
        var nu = wrap.classList.toggle('is-open');
        kop.setAttribute('aria-expanded', nu ? 'true' : 'false');
        /* Het thema zet soms een vaste hoogte op de uitgeklapte groep; na het
           openen van een familie moet die meegroeien. */
        var col = wrap.closest('.collection__filter-collapsible');
        if (col && col.getAttribute('aria-hidden') === 'false') { col.style.height = 'auto'; col.style.overflow = 'visible'; }
      });
      wrap.appendChild(kop);
      wrap.appendChild(sub);
      lijst.appendChild(wrap);
    });
  }

  function modellen() {
    var uit = [];
    try {
      new URLSearchParams(window.location.search).getAll(PARAM).forEach(function (v) {
        if (v && v !== 'Universeel' && uit.indexOf(v) < 0) { uit.push(v); }
      });
    } catch (e) { /* oude browser: geen zusterregel */ }
    return uit;
  }
  var laatsteQuery = null, leegQuery = null;
  function zuster() {
    var sectie = document.querySelector('[data-section-type="collection"][data-caasi-profiel="toestel"]');
    var oud = document.querySelector('.caasi-zuster');
    if (!sectie) { if (oud) { oud.remove(); } return; }
    var conf = ZUSTER[sectie.getAttribute('data-caasi-handle')];
    if (!conf) { return; }
    var ms = modellen();
    var q = ms.map(function (m) { return PARAM + '=' + encodeURIComponent(m); }).join('&');
    /* Chips en kruimels naar de zuster- en oudercollectie nemen het toestel mee. */
    var links = document.querySelectorAll('.caasi-catnav__chip[href], .caasi-catnav__stap[href]');
    Array.prototype.forEach.call(links, function (a) {
      var basis = a.getAttribute('data-caasi-href') || a.getAttribute('href');
      a.setAttribute('data-caasi-href', basis);
      var doel = /\/collections\/(screenprotectors|telefoonhoesjes|elektronica)(\?|$)/.test(basis);
      a.setAttribute('href', doel && q ? basis.split('?')[0] + '?' + q : basis);
    });
    if (!ms.length) { if (oud) { oud.remove(); } laatsteQuery = null; return; }
    if (q === leegQuery) { if (oud) { oud.remove(); } return; }
    if (q === laatsteQuery && oud) { return; }
    laatsteQuery = q;
    var naam = ms.length === 1 ? ms[0] : ms.slice(0, -1).join(', ') + ' en ' + ms[ms.length - 1];
    var url = '/collections/' + conf.handle + '?' + q;
    var el = oud || document.createElement('div');
    el.className = 'caasi-zuster';
    el.textContent = '';
    var vraag = document.createElement('span');
    vraag.textContent = conf.vraag.replace('%s', naam);
    var a = document.createElement('a');
    a.href = url;
    a.textContent = conf.los;
    el.appendChild(vraag);
    el.appendChild(a);
    if (!oud) {
      var toolbar = sectie.querySelector('.collection__toolbar');
      var chips = sectie.querySelector('.caasi-catnav--chips');
      if (toolbar) { toolbar.parentNode.insertBefore(el, toolbar); }
      else if (chips) { chips.parentNode.insertBefore(el, chips.nextSibling); }
      else { return; }
    }
    /* Aantal ophalen uit de zustercollectie (Section Rendering API, zelfde sectie). */
    var wrapper = sectie.closest('[id^="shopify-section-"]');
    if (!wrapper || !window.fetch) { return; }
    var mijnQuery = q;
    fetch(url + '&section_id=' + encodeURIComponent(wrapper.id.replace('shopify-section-', '')), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        if (mijnQuery !== laatsteQuery) { return; }
        var m = /"productsCount":\s*"(\d[\d.]*)/.exec(html);
        if (!m) { return; }
        var n = parseInt(m[1].replace(/\./g, ''), 10);
        if (n === 0) { leegQuery = mijnQuery; el.remove(); return; }
        a.textContent = n === 1 ? conf.een : conf.meer.replace('%n', n);
      })
      .catch(function () { /* laat de regel zonder aantal staan */ });
  }

  function zet() {
    var lijsten = document.querySelectorAll('[data-caasi-filter="geschikt-voor"] .collection__filter-checkbox-list');
    for (var i = 0; i < lijsten.length; i++) { groepeer(lijsten[i]); }
    zuster();
  }
  var wacht = null;
  function later() { clearTimeout(wacht); wacht = setTimeout(zet, 80); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', zet); } else { zet(); }
  window.addEventListener('popstate', later);
  if ('MutationObserver' in window) {
    new MutationObserver(later).observe(document.body, { childList: true, subtree: true });
  }
})();
